import React, { useEffect, useState } from 'react';
import { Modal, CloseButton } from 'react-bootstrap';
import styles from './OttServiceOptionsModal.module.scss';
import { AssetPathPropConfig } from '../../../services/LineTableBasicPropConfig';

interface GenericModalSchema {
  modalState: boolean;
  handler: () => void;
  children: React.ReactNode; // modal body
  showFooter: boolean;
  content?: any;
  footerNode?: any;
  height?: string;
  width?: string;
  backDrop?: boolean;
  backButton?: string;
}

const OttServiceOptionsModal = ({
  modalState,
  handler,
  content,
  showFooter,
  footerNode,
  children,
  height
}: GenericModalSchema): any => {
  const [slideOut, setSlideOut] = useState(false);
  const handleClose = () => {
    setSlideOut(true);

    if (typeof handler === 'function') {
      setTimeout(() => handler(), 200);
    }
  };
  useEffect(() => {
    const elem: any = document && document?.querySelector('.modal-backdrop .show');
    if (elem) {
      elem.style.opacity = 0.5;
    }

    if (modalState && document) {
      document.body.style.overflow = 'hidden';
      document.body.style.touchAction = 'none';
      // document.body.style.position = 'fixed';
      // document.body.style.top = `-${window?.screenY}px`;
    } else {
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
      document.body.style.position = '';
    }
    return () => {
      if (document) {
        document.body.style.overflow = '';
        document.body.style.touchAction = '';
        document.body.style.position = '';
      }
    };
  }, [height]);

  return (
    <Modal
      scrollable={false}
      show={modalState}
      onHide={handleClose}
      keyboard={false}
      dialogClassName={`${styles.optionsPopModal} ${slideOut && styles.closeModal}`}
      contentClassName={styles.modalContainer}
      animation={false}
    >
      <Modal.Header>
        <div className={styles.headerContainer}>
          <div className={styles.titleContainer}>
            {content?.title && <h3>{content?.title}</h3>}
            {content?.subtitle && <div className={styles.subTitle}>{content?.subtitle}</div>}
          </div>
          <div className={styles.closebtn}>
            <CloseButton className='sr-modal-close' onClick={handleClose} />
          </div>
        </div>
      </Modal.Header>
      <hr style={{ marginBottom: 0 }} />
      <Modal.Body className={styles.bodyContainer}>{children}</Modal.Body>
      <hr style={{ marginTop: 0 }} />
      {showFooter && <>{footerNode()}</>}
    </Modal>
  );
};

export default OttServiceOptionsModal;
